import {Text, type TextProps} from '@primer/react'
import {clsx} from 'clsx'

import {SanitizedHtml} from '../../dom/sanitized-html'
import styles from './text-cell.module.css'

export const TextCell = ({
  ref,
  children,
  dangerousHtml,
  className,
  isDisabled,
  ...rest
}: TextProps & {dangerousHtml?: string; isDisabled?: boolean; className?: string} & {
  ref?: React.Ref<HTMLElement>
}) => {
  if (dangerousHtml) {
    return (
      <SanitizedHtml {...rest} ref={ref} aria-disabled={isDisabled} className={clsx(className, styles.SanitizedHtml)}>
        {dangerousHtml}
      </SanitizedHtml>
    )
  }

  return (
    <Text {...rest} aria-disabled={isDisabled} ref={ref} className={clsx(className, styles.SanitizedHtml)}>
      {children}
    </Text>
  )
}

TextCell.displayName = 'TextCell'
